import { getConfig } from '@creditornot/converse-shared';
const sameTabListeners = new Map();
const getStorageKey = () => {
    const config = getConfig();
    if (config.sdkType === 'workspace') {
        return `converse-token:workspace:${config.workspaceId}${config.sessionKey ? `:${config.sessionKey}` : ''}`;
    }
    return `converse-token:widget:${config.appId}${config.sessionKey ? `:${config.sessionKey}` : ''}`;
};
const parseTokenData = (tokenData) => JSON.parse(tokenData);
const notifyTokenDataSubscribers = (tokenData) => {
    sameTabListeners.get(getStorageKey())?.forEach(listener => listener(tokenData));
};
export const removeTokenData = () => {
    window.localStorage.removeItem(getStorageKey());
    notifyTokenDataSubscribers(null);
};
export const getTokenData = () => {
    try {
        const tokenDataStr = window.localStorage.getItem(getStorageKey());
        if (tokenDataStr) {
            return parseTokenData(tokenDataStr);
        }
    }
    catch (error) {
        removeTokenData();
    }
    return;
};
export const subscribeToTokenData = (listener) => {
    const listeners = sameTabListeners.get(getStorageKey()) || new Set();
    const currentValue = getTokenData();
    if (currentValue) {
        listener(currentValue);
    }
    listeners.add(listener);
    // Cover same-tab changes to the stored token
    sameTabListeners.set(getStorageKey(), listeners);
    // Cover cross-tab changes to the stored token
    const storageListener = (event) => {
        if (event.key === getStorageKey()) {
            const tokenData = event.newValue ? parseTokenData(event.newValue) : null;
            listener(tokenData);
        }
    };
    window.addEventListener('storage', storageListener);
    return () => {
        listeners.delete(listener);
        window.removeEventListener('storage', storageListener);
    };
};
export const setTokenData = (tokenData) => {
    window.localStorage.setItem(getStorageKey(), JSON.stringify(tokenData));
    notifyTokenDataSubscribers(tokenData);
};
//# sourceMappingURL=storage.js.map